// =============================================================
// QBox Finance - Configuration
// =============================================================
// After deploying the SAM template, fill in these values from
// the CloudFormation Outputs tab in the AWS Console.
// =============================================================

const config = {
  API_URL: "https://zcqaopothl.execute-api.us-east-2.amazonaws.com/prod",
  COGNITO_DOMAIN: "qbox-finance.auth.us-east-2.amazoncognito.com",
  COGNITO_CLIENT_ID: "5tidosrsvqrlv5d015keigsk3b",
  COGNITO_REDIRECT_URI: "https://qboxbudget.com",
  COGNITO_SCOPES: "openid email profile",
  ALLOWED_EMAILS: ["larry@bigartlogistics.com","kyana@boxshopsf.com","brian@bulkowski.org","mizpoon@gmail.com","jen@clearsgnl.com","art4fire@gmail.com"],
};

export default config;
 	